export default __webpack_public_path__ + "static/media/instagram.e3bd0994.svg";